import Server from '../../api/server'
import {
  ALL_POLICIES_FOR_ORG_ROUTE,
  MEMBERS_FOR_USER_GROUP_ROUTE,
  POLICIES_FOR_USER_GROUP_ROUTE,
  POLICY_USER_GROUPS_ROUTE,
  UPDATE_GROUPS_FOR_POLICIES_ROUTE,
  UPDATE_POLICIES_FOR_GROUP_ROUTE,
  USER_GROUP_ROUTE,
  USER_GROUPS_ROUTE,
} from '../../strings/api-consts'
import {
  PolicyUserGroup,
  UpdateGroupsForPoliciesRequest,
  UpdatePoliciesForOrgUserGroupRequest,
  UserGroup,
  UserGroupMemberResponse,
  UserGroupPolicy,
  UserGroupPolicyResponse,
} from '../../types/GroupTypes'
import { CustomThunkDispatch } from '../../types/UserTypes'
import { reportErrorToDatadog } from '../../utils/error-logging'
import {
  setAllPoliciesForOrg,
  setCurrentPageMemberGroups,
  setCurrentPagePolicyGroups,
  setPolicyUserGroups,
  setTotalPagesMemberGroups,
  setTotalPagesPolicyGroups,
  setUserGroup,
  setUserGroupMembers,
  setUserGroupPolicies,
  setUserGroups,
} from './groups.slice'

const server = new Server()

export const getUserGroups = () => async (dispatch: CustomThunkDispatch) => {
  server
    .get(USER_GROUPS_ROUTE, dispatch)
    .then((res) => {
      if (!res) {
        throw new Error('Response is undefined')
      }
      return res
    })
    .then((userGroups: UserGroup[]) => {
      dispatch(setUserGroups(userGroups))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
    })
}

export const getPolicyUserGroups = (policyId: number) => async (dispatch: CustomThunkDispatch) => {
  server
    .post(POLICY_USER_GROUPS_ROUTE, { policyId: policyId }, dispatch)
    .then((res) => {
      if (!res) {
        throw new Error('Response is undefined')
      }
      return res.json()
    })
    .then((userGroups: PolicyUserGroup[]) => {
      dispatch(setPolicyUserGroups(userGroups))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
      dispatch(setPolicyUserGroups(undefined))
    })
}

export const getUserGroup = (groupId: number) => async (dispatch: CustomThunkDispatch) => {
  server
    .post(USER_GROUP_ROUTE, { groupId: groupId }, dispatch)
    .then((res) => {
      if (!res) {
        throw new Error('Response is undefined')
      }
      return res.json()
    })
    .then((userGroup: UserGroup) => {
      dispatch(setUserGroup(userGroup))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
    })
}

export const getMembersForUserGroup =
  (groupId: number, page: number, pageSize: number) => async (dispatch: CustomThunkDispatch) => {
    server
      .post(MEMBERS_FOR_USER_GROUP_ROUTE + `?page=${page}&pageSize=${pageSize}`, { groupId: groupId }, dispatch)
      .then((res) => {
        if (!res) {
          throw new Error('Response is undefined')
        }
        return res.json()
      })
      .then((userGroupMembers: UserGroupMemberResponse) => {
        dispatch(setCurrentPageMemberGroups(page - 1))
        dispatch(setUserGroupMembers(userGroupMembers.members))
        dispatch(setTotalPagesMemberGroups(userGroupMembers.totalPages))
      })
      .catch((err) => {
        reportErrorToDatadog(err.message)
      })
  }

export const getPoliciesForUserGroup =
  (groupId: number, page: number, pageSize: number) => async (dispatch: CustomThunkDispatch) => {
    server
      .post(POLICIES_FOR_USER_GROUP_ROUTE + `?page=${page}&pageSize=${pageSize}`, { groupId: groupId }, dispatch)
      .then((res) => {
        if (!res) {
          throw new Error('Response is undefined')
        }
        return res.json()
      })
      .then((userGroupPolicies: UserGroupPolicyResponse) => {
        dispatch(setCurrentPagePolicyGroups(page - 1))
        dispatch(setUserGroupPolicies(userGroupPolicies.policies))
        dispatch(setTotalPagesPolicyGroups(userGroupPolicies.totalPages))
      })
      .catch((err) => {
        reportErrorToDatadog(err.message)
      })
  }

export const getAllPoliciesForOrg = (groupId: number) => async (dispatch: CustomThunkDispatch) => {
  server
    .post(ALL_POLICIES_FOR_ORG_ROUTE, { groupId: groupId }, dispatch)
    .then((res) => {
      if (!res) {
        throw new Error('Response is undefined')
      }
      return res.json()
    })
    .then((allOrgPolicies: UserGroupPolicy[]) => {
      dispatch(setAllPoliciesForOrg(allOrgPolicies))
    })
    .catch((err) => {
      reportErrorToDatadog(err.message)
    })
}

export const updatePoliciesForGroup =
  (payload: UpdatePoliciesForOrgUserGroupRequest) => async (dispatch: CustomThunkDispatch) => {
    return server
      .post(UPDATE_POLICIES_FOR_GROUP_ROUTE, payload, dispatch)
      .then((res) => {
        if (!res) {
          return false
        }
        return true
      })
      .catch((err) => {
        reportErrorToDatadog(err.message)
        throw false
      })
  }

export const updateGroupPolicies =
  (payload: UpdateGroupsForPoliciesRequest) => async (dispatch: CustomThunkDispatch) => {
    return server
      .post(UPDATE_GROUPS_FOR_POLICIES_ROUTE, payload, dispatch)
      .then((res) => {
        if (!res) {
          return false
        }
        return true
      })
      .catch((err) => {
        reportErrorToDatadog(err.message)
        throw false
      })
  }
